export default __webpack_public_path__ + "static/media/transparency-hero.822464d7.svg";